import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Text from "../Text";

var Heading = function Heading(props) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    as: "p",
    textStyle: "h3",
    m: 0,
    mb: 2
  }, props));
};

Heading.propTypes = Text.propTypes;

var H1 = function H1(props) {
  return /*#__PURE__*/React.createElement(Heading, _extends({
    as: "h1",
    textStyle: "h1"
  }, props));
};

H1.propTypes = Heading.propTypes;

var H2 = function H2(props) {
  return /*#__PURE__*/React.createElement(Heading, _extends({
    as: "h2",
    textStyle: "h2"
  }, props));
};

H2.propTypes = Heading.propTypes;

var H3 = function H3(props) {
  return /*#__PURE__*/React.createElement(Heading, _extends({
    as: "h3",
    textStyle: "h3"
  }, props));
};

H3.propTypes = Heading.propTypes;

var H4 = function H4(props) {
  return /*#__PURE__*/React.createElement(Heading, _extends({
    as: "h4",
    textStyle: "h4"
  }, props));
};

H4.propTypes = Heading.propTypes;

var H5 = function H5(props) {
  return /*#__PURE__*/React.createElement(Heading, _extends({
    as: "h5",
    textStyle: "h5"
  }, props));
};

H5.propTypes = Heading.propTypes;

var H6 = function H6(props) {
  return /*#__PURE__*/React.createElement(Heading, _extends({
    as: "h6",
    textStyle: "h6"
  }, props));
};

H6.propTypes = Heading.propTypes;
Heading.h1 = H1;
Heading.h2 = H2;
Heading.h3 = H3;
Heading.h4 = H4;
Heading.h5 = H5;
Heading.h6 = H6;
export default Heading;